import { Breadcrumb, Col, Empty, Pagination, Radio, RadioChangeEvent, Row, Select, Space } from "antd";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { AuctionFilter } from "../../../common/components/Index";
import '../../assets/css/styles.scss'
import { BulletedList2Icon, GridViewMediumIcon } from "@fluentui/react-icons-mdl2";
import AuctionListViewOther from "./components/AuctionListViewOther";
import { AuctionSearch } from "../../types";
import { useLazySearchProductPublicQuery } from "../../../../redux/api/PublicApi";

const AuctionListOther = () => {
    const [listView, setListView] = useState(false);
    const [isMine, setIsMine] = useState(false);
    const [trigger, response] = useLazySearchProductPublicQuery();
    const [searchPrice, setSearchPrice] = useState([-1, -1]);
    const [categories, setCategories] = useState<string[]>([]);
    const [page, setPage] = useState(1);
    const [searchDate, setSearchDate] = useState(["", ""]);
    const [searchName, setSearchName] = useState("");
    const divRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        trigger({
            page: 0,
            size: 12,
            status: 124,
            type: 1,
        })
        scrollToStart();
    }, [trigger])

    const triggerSearch = (submitValue?: AuctionSearch) => {
        trigger({
            page: page - 1,
            size: (listView ? 6 : 12),
            status: 124,
            type: 1,
            searchByUserLogin: isMine,
            ...submitValue,
        })
    }

    const scrollToStart = () => {
        if (divRef.current) {
            divRef.current.scrollIntoView({ behavior: 'smooth' })
        }
    }

    const onViewSelect = (e: RadioChangeEvent) => {
        setPage(1);
        setListView(e.target.value);
        scrollToStart();
        triggerSearch({
            page: 0,
            size: (e.target.value ? 6 : 12),
            ...searchPrice[0] >= 0 ? { startPriceBegin: searchPrice[0] } : {},
            ...searchPrice[1] >= 0 ? { startPriceTo: searchPrice[1] } : {},
            ...categories ? { categoryCodes: categories } : {},
            ...searchDate[0] ? { fromDate: searchDate[0] } : {},
            ...searchDate[1] ? { toDate: searchDate[1] } : {},
            ...searchName ? { productName: searchName } : {},
        })
    }

    const onSwitchChange = (checked: boolean) => {
        setIsMine(checked);
        setPage(1);
        triggerSearch({ searchByUserLogin: checked, page: 0 })
        scrollToStart();
    }

    const onPageChange = (currentPage: number) => {
        scrollToStart();
        setPage(currentPage);
        triggerSearch({
            page: currentPage - 1,
            ...searchPrice[0] >= 0 ? { startPriceBegin: searchPrice[0] } : {},
            ...searchPrice[1] >= 0 ? { startPriceTo: searchPrice[1] } : {},
            ...categories ? { categoryCodes: categories } : {},
            ...searchDate[0] ? { fromDate: searchDate[0] } : {},
            ...searchDate[1] ? { toDate: searchDate[1] } : {},
            ...searchName ? { productName: searchName } : {},
        })
    }

    return (
        <div
            ref={divRef}
            style={{
                // padding: '40px calc((100vw - 1440px) / 2) 40px',
                background: "#ececec",
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                width: '100%',
                paddingTop: 40,
                paddingBottom: 40,
            }}
        >
            <Space style={{ display: 'flex', alignItems: 'center', marginBottom: 20 }} className="responsive-padding-1440">
                <Breadcrumb separator="  " className="custom-breadcrumb">
                    <Breadcrumb.Item>
                        <Link to="/">
                            Trang chủ
                        </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        Thông tin đấu giá
                    </Breadcrumb.Item>
                </Breadcrumb>

                <div className="responsive-title">TÀI SẢN ĐẤU GIÁ KHÁC</div>
            </Space>

            <div className="responsive-padding-1440">
                <Row gutter={30}>
                    <Col span={6}>
                        <AuctionFilter
                            setSearchDate={setSearchDate}
                            setSearchName={setSearchName}
                            categories={categories}
                            setCategories={setCategories}
                            triggerSearch={(value) => { scrollToStart(); triggerSearch(value); }}
                            setPage={setPage}
                            setSearchPrice={setSearchPrice}
                            searchDate={searchDate}
                            searchName={searchName}
                            searchPrice={searchPrice} />
                    </Col>
                    <Col span={18}>
                        <Row justify="space-between" align="middle" className="product-list-filter">
                            <Space size={20}>
                                <Radio.Group defaultValue={listView} className="filter-radio-group" onChange={(e) => onViewSelect(e)}>
                                    <Radio.Button value={true}>
                                        <BulletedList2Icon style={{ fontSize: 23 }} />
                                    </Radio.Button>
                                    <Radio.Button value={false}>
                                        <GridViewMediumIcon style={{ fontSize: 23 }} />
                                    </Radio.Button>
                                </Radio.Group>
                                <span>Số kết quả phù hợp: <span className="font-bold">{response.data?.totalElements || 0}</span></span>
                            </Space>
                            <Select
                                placeholder="Của tôi"
                                className="custom-select filter-select-small"
                                onChange={onSwitchChange}
                                value={isMine}
                            >
                                <Select.Option value={false}>Tất cả</Select.Option>
                                <Select.Option value={true}>Của tôi</Select.Option>
                            </Select>
                        </Row>

                        {response.data?.content.length ?
                            <AuctionListViewOther
                                type={listView ? "list" : "grid"}
                                auctionList={response.data?.content || []}
                                reloadPage={triggerSearch} />
                            : <Empty description="Không có dữ liệu" />}

                        <Row justify="end" align="middle" style={{ marginTop: 35, paddingRight: 37 }}>
                            <Pagination
                                defaultCurrent={1}
                                total={response.data?.totalElements || 0}
                                pageSize={listView ? 6 : 12}
                                className="custom-pagination"
                                current={page}
                                onChange={onPageChange}
                                hideOnSinglePage
                                showSizeChanger={false}
                            />
                        </Row>
                    </Col>
                </Row>
            </div>
        </div >
    )
}

export default AuctionListOther;